angular
    .module('quattro.bmbo.mailinglist.info', [])
    .directive('bmboMailinglistInfo', function () {
        return {
            templateUrl: 'bmbo/mailinglist/info.html',
        };
    });
